import EzController from 'controllers/ez-base-controller';

export default class ClickTrackController extends EzController {
  connect() {}

  track() {
    const data = this.clickFormData();
    window.navigator.sendBeacon('/api/internal/tracking/clicks', data);
  }

  clickFormData() {
    const formData = new FormData();
    formData.append(this.csrfParam, this.csrfToken);
    const { dataset } = this.element;
    for (let i = 0; i < this.element.attributes.length; i += 1) {
      const attrib = this.element.attributes[i];
      if (attrib.name.match(/^data-/)) {
        const normalized = attrib.name.replace('data-', '').replace('-', '_');
        if (!['controller', 'action'].includes(normalized)) {
          formData.append(normalized, attrib.value);
        }
      }
    }

    return formData;
  }

  normalizeParamName(name) {
    return name.split(/(?=[A-Z])/).join('_').toLowerCase();
  }
}
